var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useText } from './useText';
/**
 * # Text
 *
 * @description [vercel design text](https://vercel.com/design/text)
 *
 * 기본적인 텍스트 컴포넌트입니다. 해당 컴포넌트로 모든 텍스트를 나타냅니다.
 *
 * @param {TextProps} {@link TextProps} 기본적인 Text 요소
 *
 * @example ```tsx
 * <Text color={Colors.HIGHLIGHT.PINK} size={20} as='h1'>Hello World!</Text>
 * ```
 */
export var Text = function (props) {
    var _a = useText(props), as = _a.as, children = _a.children, transform = _a.transform, wrap = _a.wrap, otherProps = __rest(_a, ["as", "children", "transform", "wrap"]);
    var Render = Element.withComponent(as);
    return <Render {...otherProps}>{children}</Render>;
};
var fontSizeMapper = {
    10: 0.625,
    12: 0.75,
    14: 0.875,
    16: 1,
    20: 1.25,
    24: 1.5,
    32: 2,
    40: 2.5,
    48: 3
};
var Element = styled.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var size = _a.size, lineHeight = _a.lineHeight, color = _a.color, weight = _a.weight, align = _a.align, wrap = _a.wrap;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", "rem;\n    line-height: ", ";\n    \n    ", ";};\n    ", ";\n    ", ";\n\n    & strong, & bold {\n      font-weight: 800;\n    }\n  "], ["\n    color: ", ";\n    font-size: ", "rem;\n    line-height: ", ";\n    \n    ", ";};\n    ", ";\n    ", ";\n\n    & strong, & bold {\n      font-weight: 800;\n    }\n  "])), color || 'inherit', fontSizeMapper[size !== null && size !== void 0 ? size : 16], lineHeight ? "".concat(lineHeight, "px") : 1.5, weight && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        font-weight: ", ";\n      "], ["\n        font-weight: ", ";\n      "])), weight), align && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        text-align: ", ";\n      "], ["\n        text-align: ", ";\n      "])), align), !wrap && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        white-space: nowrap;\n      "], ["\n        white-space: nowrap;\n      "]))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Text.jsx.map